import ReactOnRails from 'react-on-rails';
import PageBuilder from './HelloWorld/PageBuilder';
import PageRender from './HelloWorld/PageBuilder/PageRender';
import ImageInput from './HelloWorld/PageBuilder/pickers/ImagePicker/ImageInput';
import MenuBuilder from './HelloWorld/MenuBuilder';

ReactOnRails.register({
  PageBuilder,
  PageRender,
  ImageInput,
  MenuBuilder,
});
